import * as constants from './constants'

export const addCreditCard = (customerName, cardNumber, cardExpiryMMYY, cardLastNumbers) => ({
    type: constants.ADD_CREDIT_CARD,
    customerName,
    cardNumber,
    cardExpiryMMYY,
    cardLastNumbers,
})

export const addCreditCardFailed = error => ({
    type: constants.ADD_CREDIT_CARD_FAILED,
    error,
})

export const addCreditCardSuccess = () => ({
    type: constants.ADD_PAYMENT_METHOD_SUCCESS,
})

export const resetErrorState = () => ({
    type: constants.RESET_ERROR_STATE,
})

export const addCreditCardStateReset = () => ({
    type: constants.ADD_CREDIT_CARD_RESET,
})
